import React from 'react';
import { reasonText } from '../../billMemory/core';

/**
 * Bill Memory vendor buttons (source spec, "Vendor finder"; design §9): when the bill's vendor is
 * only suggested (shop name, what they sell) or unknown, up to three likely vendors as plain
 * buttons under the vendor field — "Who is this bill from?". One tap makes the vendor certain.
 * Skipping them is fine. When the GSTIN names a different vendor than the form, one grey line
 * says so. Today's chip and grey-text styles only; no popup.
 */
export default function VendorButtons({ suggestions, gstinNote, onPick }) {
  const list = (suggestions || []).slice(0, 3);
  if (!list.length && !gstinNote) return null;
  return (
    <div className="bm-vendor-buttons">
      {gstinNote && gstinNote.vendor_name && (
        <div className="stockin-unit-cost-display">
          <span>{reasonText('gstin_vendor', { vendor: gstinNote.vendor_name })}</span>
        </div>
      )}
      {list.length > 0 && (
        <>
          <div className="stockin-unit-cost-display"><span>{reasonText('who_from', {})}</span></div>
          <div className="suggestions-row">
            {list.map((v) => (
              <button key={v.vendor_id} type="button" className="suggestion-chip" onClick={() => onPick && onPick(v)}>
                {v.name}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
